/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;

  var formatPrice = function formatPrice(value) {
    return algolia.formatMoney(Number(value) * 100).replace(/\.00$/, "");
  };

  function formattedPriceWithComparison(min_price, max_price, compare_at_price, price_ratio,tags,vendor) {
    var price = min_price < max_price ? `<span class="min-price">${formatPrice(min_price)}</span><span class="price-dash"> - </span><span class="max-price">${formatPrice(max_price)}</span>` : `<span class="min-price">${formatPrice(min_price)}</span>`;
    var discount_ratio = (tags.includes('nodiscount' ) || tags.includes('hidediscount') || tags.includes('NPISO')) ? ((compare_at_price - min_price) / compare_at_price) : compare_at_price > min_price ? ((compare_at_price - (min_price * 0.9)) / compare_at_price) : null;
    var res = Math.floor(discount_ratio * 100) < 1 || vendor === 'SB Rentals' ? 
    `
      <div class="product-card--pricing">
        <span class="font-bold">${price}</span>
      </div>
    ` : 
    min_price < max_price ?
    `
      <div class="product-card--pricing">
        <span class="font-bold">${price}</span>
        <div class="text-sb-orange text-sm">Up to ${Math.round(discount_ratio * 100)}% off</div>
      </div>
    `:`
      <div class="product-card--pricing">
        <span class="font-bold text-sb-orange">${price}</span>
        <span class="text-sb-grey-600 line-through ml-1">${formatPrice(compare_at_price)}</span>
        <div class="text-sb-orange text-sm">Up to ${Math.round(discount_ratio * 100)}% off</div>
      </div>
    `;
    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
    text,
     render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    autocompletePrice: function autocompletePrice() {
      var tags = this.tags;
      var NPISO = "NPISO";
      var YPISO = "YPISO";
      var PRELIST = "PRELIST";
      var PREORDER = "PREORDER";
      var prodDescriptor = "";
      
      // define product descriptor
      if (tags.indexOf(YPISO) > -1 || tags.indexOf(NPISO) > -1) {
        prodDescriptor = '<b>In-store Only</b><br>';
      } else {
        if (tags.indexOf(PRELIST) > -1) {
          prodDescriptor = '<b>Coming Soon</b><br>';
        } else {
          if (tags.indexOf(PREORDER) > -1) {
            prodDescriptor = '<b>Pre-Order Only</b><br>';
          }
        }
      }
      if (tags.indexOf(NPISO) > -1) {
        return prodDescriptor;
      } else {
        return prodDescriptor + formattedPriceWithComparison(
          this.variants_min_price,
          this.variants_max_price,
          this.compare_at_price,
          this.price_ratio,
          this.tags,
          this.vendor
        );
      }
    },
    instantsearchPrice: function instantsearchPrice() {
      var tags = this.tags;
      var NPISO = "NPISO";
      var YPISO = "YPISO";
      var PRELIST = "PRELIST";
      var PREORDER = "PREORDER";
      var prodDescriptor = "";
      
      // define product descriptor
      if (tags.indexOf(YPISO) > -1 || tags.indexOf(NPISO) > -1) {
        prodDescriptor = '<b>In-store Only</b><br>';
      } else {
        if (tags.indexOf(PRELIST) > -1) {
          prodDescriptor = '<b>Coming Soon</b><br>';
        } else {
          if (tags.indexOf(PREORDER) > -1) {
            prodDescriptor = '<b>Pre-Order Only</b><br>';
          }
        }
      }
      if (tags.indexOf(NPISO) > -1) {
        return prodDescriptor;
      } else {
        return prodDescriptor + formattedPriceWithComparison(
          this.variants_min_price,
          this.variants_max_price,
          this.compare_at_price,
          this.price_ratio,
          this.tags,
          this.vendor
        );
      }
    },
    instantsearchLink: function instantsearchLink() {
      var addVariantId = !this._distinct && this.objectID !== this.id;
      return (
        '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }

      return escapeHtml(res);
    },
    fullHTMLTitle: function fullHTMLTitle() {
      var res = this._highlightResult.title.value;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
      .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = algolia.helpers.fullEscapedAttribute(
        this._highlightResult.title.value
      );
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.product_type.value
      );
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      return algolia.helpers.fullEscapedAttribute(
        this._highlightResult.vendor.value
      );
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
    
    // custom helpers
    rentalOverlay: function rentalOverlay() {
      var res = '';
      var tags = this.tags;
      var buttons = new Array();
      var rentalsDownURL = "/pages/rental-reservations-currently-down";
      if(Array.isArray(this.named_tags.https)) {
        var https = this.named_tags.https;
        https.forEach(function(link) {
          buttons.push(link);
        });
      } else {
        buttons.push(this.named_tags.https);
      }

      if (tags.includes('OLDRENTAL')) {

        if (!Array.isArray(buttons) || !buttons.length) { 
            res += '<div class="rental-overlay"><div class="inner text-center p-2 w-full"><div class="h3">Rental</div><div><a href="https://rentals.sportsbasement.com" class="btn primary m-2 px-4 py-1" aria-label="View Rentals Site">View Rentals Site</a></div></div></div>';
        } else {
          res += '<div class="rental-overlay"><div class="inner text-center p-2 w-full"><div class="h3">Rental</div>';
          buttons.forEach(function(button) {
            res += '<div><a href="' + button + '" class="btn primary m-2 px-4 py-1" ';
            if (button.includes('?ship')) {
              res += 'aria-label="Ship to Home">Ship To Home';
            } else {
              if (button.includes('?subscription')) {
                res += 'aria-label="Monthly Rental">Monthly Rental';
              } else {
                res += 'aria-label="In-store Pickup">In-store Pickup';
              }
            }
            res += '</a></div>';
          });
          res += '<div class="h6">proceed to rental site</divs>';
          res += '<div class="rentalVariants mt-4 mb-3"></div>';
          res += '</div></div>';
          return (res);
        }
      }
    },
    productFlag: function productFlag() {
      var flags = ['Demo','Rental','Staff Pick','PREORDER'];
      var tags = this.tags;
      var discount = (tags.includes('nodiscount' ) || tags.includes('hidediscount') || tags.includes('NPISO')) ? ((this.compare_at_price - this.variants_min_price) / this.compare_at_price) : this.compare_at_price > this.variants_min_price ? ((this.compare_at_price - (this.variants_min_price * 0.9)) / this.compare_at_price) : null;
      var res = '';

      // if (discount && Math.floor(discount * 100) > 10) {
      //   if (tags.includes('NPISO') || this.vendor === 'SB Rentals') { } else {
      //     res += '<span class="product-flag h6 savings"></span>';
      //   }
      // }
      flags.forEach(function(flag) {
        if (tags.includes('Demo') && flag === 'Rental') return; // if demo, skip rental flag
        if (tags.includes(flag)) {
          var flagClass = flag.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
          res += '<span class="product-flag h6 ' + flagClass + '">' + flag + '</span>';
        }
      });
      return (res);
    },
    facetItemClass: function facetItemClass() {
      var faceItemClass = 'ais-facetItem--' + this.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      return faceItemClass;
    },
    facetItemOrder: function facetItemOrder() {
      var faceItemClass = 'ais-facetItem--' + this.label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      var letterSizes= ["XXS","XS","S","M","L","XL","XXL"];
      var value = this.label;
      if (jQuery.inArray(value, letterSizes) !== -1) {
        return jQuery.inArray(value, letterSizes) + 1;
      } else {
        var reg = /\D/g;
        var match = value.match(reg);
        if (match) {
          var valueSplit = value.split(match[0]);
          var valueOrder = (valueSplit[0] * 1) + 10;
          return valueOrder;
        } else {
          var valueOrder = (value * 1) + 10;
          return valueOrder;
        }
      }
    },


  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
    '192x192',
    '222x222',
    '280x280',
    '290x290',
    '310x310',
    '320x320',
    '352x352',
    '382x382',
    '404x404',
    '433x433',
  ].forEach(function(size) {
    algolia.helpers[`${size}Image`] = (function(_size) {
    return function() {
      // var image = this._distinct ? this.product_image : this.image; /* render main product image if distinct */
      var image = this.image; /* always render variant image */

      if (!image) {
        return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
      }

      if (_size === 'original') {
        return image;
      }

      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
    };
  })(size); // We need to create a new scope so that the internal size has the good value.
});

/* Create an Hogan lambda, which doesn't respect the mustache doc */
var helpers = algolia.assign(
  {},
  algolia.helpers,
  algolia.translation_helpers
);
var helpersNames = Object.keys(helpers);
var i = helpersNames.length;
var helpersArray = new Array(i);
while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
  var name = options[0];
  var helper = options[1];

  var newRes = algolia.assign({}, res);

  newRes[name] = function() {
    return function(text) {
      var render = function(value) {
        return Hogan.compile(value, algolia.hoganOptions).render(this);
      }.bind(this);

      return helper.call(this, text, render);
    }.bind(this);
  };

  return newRes;
}, {});
})(window.algoliaShopify);